import React, { useState } from "react";
import { Badge, Form } from "react-bootstrap";
import PlacesAutocomplete, { geocodeByAddress } from "react-places-autocomplete";

// Sélection de 0 à N villes via Google Places (autocomplete restreint aux villes),
// pour éviter les variantes de saisie libre ("Nice" / "NICE" / "Nice, France"...).
// Stocke uniquement le nom de la ville (pas l'adresse complète ni les coordonnées).
const searchOptions = {
  componentRestrictions: { country: ["fr", "mc"] },
  types: ["(cities)"],
};

function ZoneActiviteInput({ villes, onChange }) {
  const [input, setInput] = useState("");

  const extractCityName = (result) => {
    const cityComponent = result.address_components?.find(
      (c) => c.types.includes("locality") || c.types.includes("postal_town")
    );
    return cityComponent?.long_name || result.formatted_address;
  };

  const handleSelect = async (address) => {
    try {
      const results = await geocodeByAddress(address);
      const ville = results.length > 0 ? extractCityName(results[0]) : address;
      if (ville && !villes.includes(ville)) {
        onChange([...villes, ville]);
      }
    } catch (e) {
      console.error("Erreur géocodage ville", e);
    } finally {
      setInput("");
    }
  };

  const removeVille = (ville) => {
    onChange(villes.filter((v) => v !== ville));
  };

  return (
    <div>
      <div className="d-flex flex-wrap gap-2 mb-2">
        {villes.map((v) => (
          <Badge key={v} bg="secondary" className="d-flex align-items-center gap-1" style={{ fontSize: 13, padding: "6px 10px" }}>
            {v}
            <span role="button" onClick={() => removeVille(v)} style={{ cursor: "pointer", marginLeft: 4 }} title="Retirer">×</span>
          </Badge>
        ))}
      </div>
      <PlacesAutocomplete value={input} onChange={setInput} onSelect={handleSelect} searchOptions={searchOptions}>
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div style={{ position: "relative" }}>
            <Form.Control
              {...getInputProps({ placeholder: "Ajouter une ville..." })}
              size="sm"
            />
            {(loading || suggestions.length > 0) && (
              <div className="border rounded bg-white shadow-sm" style={{ position: "absolute", zIndex: 10, width: "100%" }}>
                {loading && <div className="p-2 small text-muted">Chargement...</div>}
                {suggestions.map((s) => (
                  <div
                    key={s.placeId}
                    {...getSuggestionItemProps(s, {
                      style: { padding: "6px 10px", cursor: "pointer", backgroundColor: s.active ? "#f0f4ff" : "#fff" },
                    })}
                  >
                    {s.description}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </PlacesAutocomplete>
    </div>
  );
}

export default ZoneActiviteInput;
